import React from "react";

const Inmetro = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiNGJjOGFlZDktMTFjNC00ZWM2LTljNGYtYjc4YWU3YmMxYTNiIiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default Inmetro;
